// const pre=`http://localhost:2929/`;
const pre=`https://www.backendgamevista.gameninja.in/`;
// const pre=`http://5.189.146.57:9049/GamePortalBackendNewLiveDemo/`;
const getGamesApi=`${pre}games`;
export{getGamesApi};

// http://5.189.166.187:5551/GamePortalBackendNewLiveDemo/sendGames